<h1 mat-dialog-title class="pt-2 text-center"> Changement de zone</h1>
<div mat-dialog-content class="p-0">
    <div class="container no-gutters">

        <div class="row m-0">
            <mat-form-field class="col">
                <mat-select placeholder="Zones" [(ngModel)]="SelectedZone">
                    @for (z of ZoneList; track z; let i = $index) {
                    <mat-option [value]="z">
                        Zone {{ z.Name }} @if (z.CustomerReference) {
                        <span>({{ z.CustomerReference}})</span>
                        }
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="row m-1">
            <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
                Annuler
            </button>
            <button appPreventDoubleClick class="col ms-1" mat-raised-button color="primary" (throttledClick)="finish()">
                Ajouter
            </button>
        </div>
    </div>
</div>